// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'

// Internal Dependencies:
import Page from 'views/pages/basic-page/Page'
import Footer from 'components/Footer/Footer'
import { get } from 'utilities/objects'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class BasicPageLayout extends React.Component {
	render() {
		let { hasSidebar, location, match, page, isMobile, fullWidth } = this.props
		const thisPageSlug = get( [ 'page' ] )( match.params, false )
		let className = ''

		let showPrimaryContent = true,
			showSecondaryContent = true

		if ( page && page.template ) {
			className += ` page-${page.template}`

			if ( 'blog' == page.template ) {
				fullWidth = true
			}
		}

		if ( fullWidth ) {
			className += ` page-full-width`
		}

		return (
			<div className={ className }>
				<div className="main-inner">
					{ showPrimaryContent &&
						<div className="primary-wrap">
							<div className="primary-content">
								<Page { ...this.props } />
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected,
		isMobile: state.site.isMobile
	}
}

export default withRouter(
	connect( mapStateToProps )( BasicPageLayout )
)



// WEBPACK FOOTER //
// ./views/layouts/BasicPageLayout.jsx